[
    {
        "category": "😻 I Love You",
        "folder": "a",
        "count": 1,
        "description": "DPIXXI: Test Designs Before You Buy!",
        "url": "https://dpixxi.com"
    },
    {
        "category": "😽 Big Kisses",
        "folder": "b",
        "count": 1,
        "description": "DPIXXI: Test Designs Before You Buy!",
        "url": "https://dpixxi.com"
    },
    {
        "category": "😸 Big Mouth",
        "folder": "c",
        "count": 1,
        "description": "DPIXXI: Test Designs Before You Buy!",
        "url": "https://dpixxi.com"
    },
    {
        "category": "😼 Coffee Time",
        "folder": "d",
        "count": 1,
        "description": "DPIXXI: Test Designs Before You Buy!",
        "url": "https://dpixxi.com"
    },
    {
        "category": "😿 Sad",
        "folder": "e",
        "count": 1,
        "description": "DPIXXI: Test Designs Before You Buy!",
        "url": "https://dpixxi.com"
    }
]
